var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"parent parent-2"},[_c('v-card',{on:{"click":_vm.openLink}},[_c('v-card-title',{staticClass:"info-title"},[_c('div',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.link.Title)+" ")])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }